module.exports = __webpack_public_path__ + "img/free-to-play.92f279bd.png";